import * as React from 'react';
import { tooltipDriverFactory as tooltipUniDriverFactory } from './Tooltip.driver';
import { createRendererWithUniDriver } from '../../test/utils';
import { Tooltip } from './Tooltip';

describe('Tooltip', () => {
  const createDriver = createRendererWithUniDriver(tooltipUniDriverFactory);
  const bootstrap = () => {
    return createDriver(
      <Tooltip
        placement="bottom"
        timeout={0}
        content={<div>Hello world</div>}
        showDelay={0}
      >
        <div>Element</div>
      </Tooltip>,
    );
  };

  it('should be hidden by default', async () => {
    const { driver } = bootstrap();
    expect(await driver.tooltipExists()).toBe(false);
  });

  it('should render tooltip on mouse enter', async () => {
    const { driver } = bootstrap();
    await driver.mouseEnter();
    expect(await driver.tooltipExists()).toEqual(true);
  });
});
